import gqlRequest from 'graphql/generic';

type GetOrderForSettlement = {
  getOrder: {
    accounting: any[];
    parties: Array<{
      _id: string;
      kinds: string[];
      name: string;
      member_of: Array<{
        _id: string;
        kind: string;
        name: string;
      }>;
    }>;
  };
};

type GetOrderParams = { id: string };

const query = `
  query GetOrder($id: ID!) {
    getOrder(_id: $id) {
      accounting {
        _id
        amount
        amount_calculated
        amount_override
        amount_faked
        code
        kind
        letter
        number
        entry_date
        description
        months
        per_month
        posted
        accounted_for {
          amount
          percent
          record {
            _id
            code
            number
            amount
            amount_faked
            letter
            description
            involved_parties {
              _id
              name
              kind
            }
          }
        }
        involved_parties {
          _id
          amount
          at_closing_amount
          at_closing_percent
          before_closing_amount
          before_closing_percent
          kind
          name
          order_kinds
          payment_id
          payment_kind
          payment_reference
          percent
          accounted_amount
          accounted_percent
           accounted_by {
             amount
             percent
             record {
               _id
               description
               code
               letter
               number
             }
           }
        }
      }
      parties {
        _id
        kinds
        name
        member_of {
          _id
          kind
          name
        }
      }
    }
  }
`;

export const getOrderForSettlement = (id: string) =>
  gqlRequest<GetOrderForSettlement, GetOrderParams>(query, { id });
